export enum CategoryKeys {
  LATEST_TREATMENT_OPTIONS = 'latest_treatment_options',
  TREATMENT_OPTIONS = 'treatment_options',
  DIFFERENTIAL_DIAGNOSIS = 'differential_diagnosis',
  DRUGS_TREATMENT = 'drugs_treatment',
}

/**
 * Category ID mappings for fallback when category_key is not available
 */
export const CategoryIDs = {
  DIFFERENTIAL_DIAGNOSIS: [1, 69, 53, 316], // Physician, Nurse, Surgeon, Others
  LATEST_TREATMENT_OPTIONS: [4],
  TREATMENT_OPTIONS: [3],
  DRUGS_TREATMENT: [6],
} as const;

/**
 * Category key mappings for enhanced table functionality
 */
export const ENHANCED_TABLE_CATEGORY_KEYS = [
  CategoryKeys.DIFFERENTIAL_DIAGNOSIS,
  CategoryKeys.LATEST_TREATMENT_OPTIONS,
  CategoryKeys.TREATMENT_OPTIONS,
  CategoryKeys.DRUGS_TREATMENT,
] as const;

/**
 * Helper function to check if a category key supports enhanced tables (checkboxes)
 */
export const isEnhancedTableCategory = (categoryKey?: string): boolean => {
  if (!categoryKey) return false;
  return ENHANCED_TABLE_CATEGORY_KEYS.includes(categoryKey as CategoryKeys);
};

/**
 * Helper function to check if category is differential diagnosis
 */
export const isDifferentialDiagnosisCategory = (categoryKey?: string): boolean => {
  return categoryKey === CategoryKeys.DIFFERENTIAL_DIAGNOSIS;
};

/**
 * Helper function to check if category is latest treatment options or treatment options
 */
export const isLatestTreatmentOptionsCategory = (categoryKey?: string): boolean => {
  return (
    categoryKey === CategoryKeys.LATEST_TREATMENT_OPTIONS ||
    categoryKey === CategoryKeys.TREATMENT_OPTIONS
  );
};

/**
 * Helper function to check if category is drugs treatment
 */
export const isDrugsTreatmentCategory = (categoryKey?: string): boolean => {
  return categoryKey === CategoryKeys.DRUGS_TREATMENT;
};

/**
 * Helper function to get category_key from category ID (fallback when category_key is missing)
 */
export const getCategoryKeyByIdFallback = (categoryId?: number): string | null => {
  if (!categoryId) return null;

  if (CategoryIDs.DIFFERENTIAL_DIAGNOSIS.includes(categoryId as any)) {
    return CategoryKeys.DIFFERENTIAL_DIAGNOSIS;
  }
  if (CategoryIDs.LATEST_TREATMENT_OPTIONS.includes(categoryId as any)) {
    return CategoryKeys.LATEST_TREATMENT_OPTIONS;
  }
  if (CategoryIDs.TREATMENT_OPTIONS.includes(categoryId as any)) {
    return CategoryKeys.TREATMENT_OPTIONS;
  }
  if (CategoryIDs.DRUGS_TREATMENT.includes(categoryId as any)) {
    return CategoryKeys.DRUGS_TREATMENT;
  }

  return null;
};